module.exports = __webpack_public_path__ + "static/media/sf_attraction_11.cf7e7a04.jpg";